import React, { createContext, useState, useContext, useEffect } from 'react';
import { supabase } from '../util/supabaseClient';

// 초기 상태
const initialState = {
  session: null,
  user: null,
  isLoading: false,
  error: null
};

// Context 생성
const AppContext = createContext(initialState);

// Custom hook을 만들어 Context 사용을 더 쉽게 함
export const useAppContext = () => {
  return useContext(AppContext);
};

// Provider 컴포넌트
export const AppProvider = ({ children }) => {
  // 상태 정의
  const [session, setSession] = useState(null);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // 상태 변경 함수들
  const setLoadingState = (loading) => {
    setIsLoading(loading);
  };

  const setErrorState = (errorMessage) => {
    setError(errorMessage);
  };

  const clearError = () => {
    setError(null);
  };

  // 인증 관련 처리를 위한 useEffect
  useEffect(() => {
    // 현재 세션 정보를 가져오기
    setIsLoading(true);
    
    // 초기 세션 로드
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setUser(data.session?.user || null);
      setIsLoading(false);
    }).catch(error => {
      setError(error.message);
      setIsLoading(false);
    });

    // 인증 상태 변경 리스너
    const { data: authListener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session);
        setUser(session?.user || null);
      }
    );

    // 컴포넌트 언마운트 시 리스너 제거
    return () => {
      authListener?.subscription?.unsubscribe();
    };
  }, []);

  // Context에 제공할 값
  const contextValue = {
    session,
    user,
    isLoading,
    error,
    setLoadingState,
    setErrorState,
    clearError
  };

  return (
    <AppContext.Provider value={contextValue}>
      {children}
    </AppContext.Provider>
  );
}; 